export const DEMO_SEED = 20260805;

export function mulberry32(seed) {
  let a = seed >>> 0;
  return function next() {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function stripApostrophes(value) {
  return typeof value === 'string' ? value.replace(/['‘’`]/g, '') : value;
}

export function toISODate(date) {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseISODate(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

export function addDays(iso, days) {
  const date = parseISODate(iso);
  date.setUTCDate(date.getUTCDate() + days);
  return toISODate(date);
}

export function daysBetween(startISO, endISO) {
  return Math.round((parseISODate(endISO).getTime() - parseISODate(startISO).getTime()) / 86400000);
}

export function createRandom(seed = DEMO_SEED) {
  const next = mulberry32(seed);

  const rand = () => next();

  const int = (min, max) => min + Math.floor(next() * (max - min + 1));

  const decimal = (min, max, places = 2) => {
    const factor = Math.pow(10, places);
    return Math.round((min + next() * (max - min)) * factor) / factor;
  };

  const pick = (items) => items[Math.floor(next() * items.length)];

  const chance = (probability) => next() < probability;

  const weighted = (entries) => {
    const pairs = Array.isArray(entries) ? entries : Object.entries(entries);
    const total = pairs.reduce((sum, pair) => sum + pair[1], 0);
    let roll = next() * total;
    for (const [value, weight] of pairs) {
      roll -= weight;
      if (roll <= 0) return value;
    }
    return pairs[pairs.length - 1][0];
  };

  const shuffle = (items) => {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(next() * (i + 1));
      const tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy;
  };

  const dateBetween = (startISO, endISO) => {
    const span = daysBetween(startISO, endISO);
    if (span <= 0) return startISO;
    return addDays(startISO, int(0, span));
  };

  const dateTimeBetween = (startISO, endISO) => {
    const day = dateBetween(startISO, endISO);
    const hh = String(int(6, 19)).padStart(2, '0');
    const mm = String(int(0, 59)).padStart(2, '0');
    const ss = String(int(0, 59)).padStart(2, '0');
    return `${day}T${hh}:${mm}:${ss}Z`;
  };

  return {
    rand,
    int,
    decimal,
    pick,
    chance,
    weighted,
    shuffle,
    dateBetween,
    dateTimeBetween,
  };
}
